import React from 'react';
import './WidgetCard.less';
import classNames from 'classnames';

export default function WidgetCard(props) {
  return (
    <div
      className={classNames({
        'widget-card': true,
        'inactive': props.inactive
      })}
      onClick={props.onClick}
    >
      <p style={props.textStyle}>{props.name}</p>
    </div>
  );
}
